import {useEffect, useState} from 'react';

import {getAttributesUsageByIds, getAttributesUsageByIdsSuccess} from 'src/openapi/apis/AttributeControllerApi';
import {AttributeUsage} from 'src/openapi/models/AttributeUsage';
import {useAppDispatch} from 'src/store';

export const useAttributeUsage = (
    attributeIds: Array<number>,
): Array<AttributeUsage> => {
    const dispatch = useAppDispatch();
    const [attributesUsage, setAttributesUsage] = useState<Array<AttributeUsage>>([]);

    useEffect(() => {
        if (attributeIds) {
            dispatch(getAttributesUsageByIds({ids: attributeIds})).then(e => {
                if (!e.payload.error && e.type === getAttributesUsageByIdsSuccess.type) {
                    setAttributesUsage(e.payload.data);
                }
            });
        }
    }, [attributeIds, dispatch]);

    return attributesUsage;
};
